import { render } from "./unauthorized-tooltip.vue?vue&type=template&id=62b18ab5&ts=true"
import script from "./unauthorized-tooltip.vue?vue&type=script&lang=ts"
export * from "./unauthorized-tooltip.vue?vue&type=script&lang=ts"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__